function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/**
 * A Tag categorizes or marks anything.
 *
 * @return {jsx}
 */

var Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["children", "className", "color"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, rest, {
    "data-testid": "tag"
  }), children);
};
/**
 * PropTypes Validation.
 */


var node = PropTypes.node,
    string = PropTypes.string;
Tag.propTypes = {
  /** Anything that can be rendered: numbers, strings, elements or an array (or fragment) */
  children: node,

  /** className needed by styled-components */
  className: string,

  /** The background color of the tag box */
  color: string
};
/**
 * Default props.
 */

Tag.defaultProps = {
  children: null,
  className: '',
  color: ''
};
export default styled(Tag).withConfig({
  displayName: "Tag",
  componentId: "o42tbb-0"
})(["position:relative;display:inline-block;padding:0.4rem 0.8rem;border-radius:0.5rem;color:", ";background:", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
});